import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Grid2,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import events1 from "../../assets/images/events_1.png";
import events2 from "../../assets/images/events_2.png";
import locationSmall from "../../assets/images/location-small.svg";
import userSmall from "../../assets/images/user-small.svg";
import dateSmall from "../../assets/images/date-small.svg";
import ResellPNG from "../../assets/images/resell.png";
import TransactionPNG from "../../assets/images/transaction.png";
import ViewPNG from "../../assets/images/view.png";
import closeBtn from "../../assets/images/close.svg";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";
import Snackbars from "../../utils/Snackbars";

const Myticket = () => {
  const [open, setOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const { getRequest } = useRequests();
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("upcoming");
  const handleTabClick = (tab) => setSelectedTab(tab);
  const handleOpen = (ticket) => {
    setSelectedTicket(ticket);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTicket(null);
  };

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [tickets, setTickets] = useState([]);
  const [pasttickets, setPastTickets] = useState([]);
  const [bannerUrl, setbannerUrl] = useState(null);

  const fetchTickets = async () => {
    const response = await getRequest("user-purchased-tickets");

    if (response && response.code === 200) {
      if(response.data.length!=0){

      const ticketsData = Array.isArray(response.data.data)
        ? response.data.data
        : [response.data.data];

        
      // const ValidTickets = ticketsData.filter((ticket) => ticket.quantity != 0 && ticket.used != true);

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const ValidTickets = ticketsData.filter((ticket) => {
        let eventdate;
        if(ticket.event_ticket_date){
          eventdate = ticket.event_ticket_date;
        }else{
          eventdate = ticket.end_datetime;
        }
        if(ticket.day_pass =="1"){
          return ticket.quantity != 0 && ticket.used !== true && today <= new Date(eventdate) && ticket.ticket_status =="Enable";
        }else{
          return ticket.quantity != 0 && today <= new Date(eventdate) && ticket.ticket_status =="Enable";
        }
      });

      const PastTickets = ticketsData.filter((ticket) => {
        let eventdate;
        if(ticket.event_ticket_date){
          eventdate = ticket.event_ticket_date;
        }else{
          eventdate = ticket.end_datetime;
        }
        if(ticket.day_pass =="1"){
          return ticket.quantity != 0 && today > new Date(eventdate) && ticket.ticket_status =="Enable";
        }else{
          return ticket.quantity != 0 && today > new Date(eventdate) && ticket.ticket_status =="Enable";
        }
      });

      setTickets(ValidTickets);
      setPastTickets(PastTickets);
      setbannerUrl(response.data.banner);
      }
    } else {
      console.error("Failed to fetch events:", response?.message);
      setAlertData((prev) => ({
        ...prev,
        variant: "error",
        message: "Failed to fetch events",
      }));
    }
    resetAlertData();
    setLoading(false);
  };

    const [maxEventDays, setMaxEventDays] = useState(1);
    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return Math.min(diffDays, 10); // Max 10 days
    };

  React.useEffect(() => {
    fetchTickets();
  }, []);

  const formatEventDate = (start, end, time, ticketDate, transaction_date) => {
    const parseDate = (dateString) => {
      if (!dateString) return null;
      if (dateString.length === 10 && dateString.includes('-')) {
        return new Date(dateString + 'T00:00:00');
      }
      return new Date(dateString);
    };

    const startDate = parseDate(start);
    const endDate = parseDate(end);
    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    // Fix ticket date parsing
    let ticketFormatedDate = "";
    if (ticketDate) {
      const ticket_date = parseDate(ticketDate);
      const ticketDay = format(ticket_date, "dd");
      const ticketMonth = format(ticket_date, "MMMM");
      const ticketYear = format(ticket_date, "yyyy");
      ticketFormatedDate = `${ticketDay} ${ticketMonth} ${ticketYear}`;
    }

    // Fix transaction date parsing
    let formatedTransactionDate = "";
    if (transaction_date) {
      const transactiontDate = parseDate(transaction_date);
      const transactiontDay = format(transactiontDate, "dd");
      const transactiontmonth = format(transactiontDate, "MMMM");
      const transactiontyear = format(transactiontDate, "yyyy");
      formatedTransactionDate = `${transactiontDay} ${transactiontmonth} ${transactiontyear}`;
    }

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate,
        formatedTransactionDate,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate,
      formatedTransactionDate,
    };
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="center-App" container direction="column">
        <Header name="My Tickets" />
        <Box
          sx={{
            padding: "15px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                minHeight: "300px",
              }}
            >
              <CircularProgress color="primary" />
              <p>Loading ...</p>
            </Box>
          ) : (
            <>
                      <Grid2 className="ticketType" sx={{ marginBottom: "15px" }}>
                        <Grid2
                          className={`ticketName ${selectedTab === "upcoming" ? "selected" : ""}`}
                          onClick={() => handleTabClick("upcoming")}
                          sx={{
                            cursor: "pointer",
                            padding: "10px 20px",
                            backgroundColor: selectedTab === "upcoming" ? "#6638A2" : "#f5f5f5",
                            color: selectedTab === "upcoming" ? "white" : "#666",
                            borderRadius: "8px",
                            textAlign: "center",
                            fontWeight: "500",
                            marginRight: "10px",
                          }}
                        >
                          Upcoming Tickets
                        </Grid2>
                        <Grid2
                          className={`ticketName ${selectedTab === "past" ? "selected" : ""}`}
                          onClick={() => handleTabClick("past")}
                          sx={{
                            cursor: "pointer",
                            padding: "10px 20px",
                            backgroundColor: selectedTab === "past" ? "#6638A2" : "#f5f5f5",
                            color: selectedTab === "past" ? "white" : "#666",
                            borderRadius: "8px",
                            textAlign: "center",
                            fontWeight: "500",
                          }}
                        >
                          Past Tickets
                        </Grid2>
                      </Grid2>
                      {selectedTab === "upcoming"?
                        <div container spacing={2}>
              {tickets.length > 0 ? (
                tickets.map((ticket) => {
                  const { formattedDate, daysCount, time, ticketFormatedDate } =
                    formatEventDate(
                      ticket.start_datetime,
                      ticket.end_datetime,
                      ticket.start_time + " - " + ticket.end_time,
                      ticket.event_ticket_date,
                      ticket.transaction_date
                    );
                  return (
                    <div item xs={12} key={ticket.ut_id}>
                      <Box className="events-box">
                        <Card
                          sx={{
                            borderRadius: "10px",
                            padding: "15px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div
                            className="position-relative radius-img-box"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CardMedia
                              component="img"
                              height="185"
                              image={bannerUrl + ticket.banner}
                              alt={ticket.name}
                              className="small-event-img"
                            />
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{
                                float: "left",
                                width: "calc(100% - 80px)",
                                color: "#6638A2",
                                marginTop: "5px",
                                fontSize: "21px",
                                marginBottom: "10px",
                                lineHeight: "27px",
                                fontWeight: "500",
                                paddingLeft: "15px",
                              }}
                            >
                              {ticket.name}
                            </Typography>
                          </div>
                          <CardContent style={{ padding: "9px 5px" }}>
                            <CardContent style={{ padding: "0px 5px 0" }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={userSmall}
                                  alt=""
                                  className="small-svg"
                                />
                                <span
                                  style={{ float: "left", marginTop: "2px" }}
                                >{`${ticket.type} Ticket, ${ticket.day_pass} Day Pass, ${ticket.quantity} Person`}</span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={dateSmall}
                                  alt=""
                                  className="small-svg"
                                />
                                <span
                                  style={{ float: "left", marginTop: "5px" }}
                                >
                                  {ticket.day_pass == 1
                                    ? ticketFormatedDate + ", " + time
                                    : formattedDate + ", " + time}
                                </span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={locationSmall}
                                  alt=""
                                  className="small-svg"
                                />
                                <span
                                  style={{ float: "left", marginTop: "4px" }}
                                >
                                  {ticket.address}
                                </span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                }}
                              >
                                <span
                                  style={{
                                    float: "left",
                                    marginTop: "10px",
                                    color: "#028E54",
                                    fontSize: "18px",
                                    textTransform: "uppercase",
                                    fontWeight: "500",
                                    paddingLeft: "30px",
                                  }}
                                >
                                  Ticket Price ₹ {ticket.purchase_price}
                                </span>
                              </Typography>

                              <Grid2 className="list-View">
                                <Grid2 className="details">
                                  <Link
                                    to={`/my-tickets/ticket-details/${btoa(ticket.ut_id)}`}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <img
                                      src={ViewPNG}
                                      alt=""
                                      className="small-svg ViewPNG"
                                    />
                                    <Typography variant="span">View</Typography>
                                  </Link>
                                </Grid2>
                                <Grid2 className="details">
                                  <Link
                                    onClick={() => handleOpen(ticket)}
                                    style={{
                                      textDecoration: "none",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={TransactionPNG}
                                      alt=""
                                      className="TransactionPNG small-svg"
                                    />
                                    <Typography variant="span">
                                      Transaction
                                    </Typography>
                                  </Link>
                                </Grid2>
                                {ticket.assigned_organizer == 0 && ticket.resellstatus == "On"?
                                <Grid2 className="details">
                                  <Link
                                    to={`/my-tickets/resell-ticket-details/${ticket.ut_id}`}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <img
                                      src={ResellPNG}
                                      alt=""
                                      className="small-svg ResellPNG"
                                    />
                                    <Typography variant="span">
                                      Resell
                                    </Typography>
                                  </Link>
                                </Grid2>
                                :""
                                }
                                
                              </Grid2>
                            </CardContent>
                          </CardContent>
                        </Card>
                      </Box>
                    </div>
                  );
                })
              ) : (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: "center", marginTop: "20px" }}
                >
                  No tickets found.
                </Typography>
              )}
            </div>
                        :
                        <div container spacing={2}>
              {pasttickets.length > 0 ? (
                pasttickets.map((ticket) => {
                  const { formattedDate, daysCount, time, ticketFormatedDate } =
                    formatEventDate(
                      ticket.start_datetime,
                      ticket.end_datetime,
                      ticket.start_time + " - " + ticket.end_time,
                      ticket.event_ticket_date,
                      ticket.transaction_date
                    );
                  return (
                    <div item xs={12} key={ticket.ut_id}>
                      <Box className="events-box">
                        <Card
                          sx={{
                            borderRadius: "10px",
                            padding: "15px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div
                            className="position-relative radius-img-box"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CardMedia
                              component="img"
                              height="185"
                              image={bannerUrl + ticket.banner}
                              alt={ticket.name}
                              className="small-event-img"
                            />
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{
                                float: "left",
                                width: "calc(100% - 80px)",
                                color: "#6638A2",
                                marginTop: "5px",
                                fontSize: "21px",
                                marginBottom: "10px",
                                lineHeight: "27px",
                                fontWeight: "500",
                                paddingLeft: "15px",
                              }}
                            >
                              {ticket.name}
                            </Typography>
                          </div>
                          <CardContent style={{ padding: "9px 5px" }}>
                            <CardContent style={{ padding: "0px 5px 0" }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={userSmall}
                                  alt=""
                                  className="small-svg"
                                />
                                <span
                                  style={{ float: "left", marginTop: "2px" }}
                                >{`${ticket.type} Ticket, ${ticket.day_pass} Day Pass, ${ticket.quantity} Person`}</span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={dateSmall}
                                  alt=""
                                  className="small-svg"
                                />
                                <span
                                  style={{ float: "left", marginTop: "5px" }}
                                >
                                  {ticket.day_pass == 1
                                    ? ticketFormatedDate + ", " + time
                                    : formattedDate + ", " + time}
                                </span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={locationSmall}
                                  alt=""
                                  className="small-svg"
                                />
                                <span
                                  style={{ float: "left", marginTop: "4px" }}
                                >
                                  {ticket.address}
                                </span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "7px",
                                }}
                              >
                                <span
                                  style={{
                                    float: "left",
                                    marginTop: "10px",
                                    color: "#028E54",
                                    fontSize: "18px",
                                    textTransform: "uppercase",
                                    fontWeight: "500",
                                    paddingLeft: "30px",
                                  }}
                                >
                                  Ticket Price ₹ {ticket.purchase_price}
                                </span>
                              </Typography>

                              <Grid2 className="list-View">
                                <Grid2 className="details">
                                  <Link
                                    to={`/my-tickets/ticket-details/${btoa(ticket.ut_id)}`}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <img
                                      src={ViewPNG}
                                      alt=""
                                      className="small-svg ViewPNG"
                                    />
                                    <Typography variant="span">View</Typography>
                                  </Link>
                                </Grid2>
                                <Grid2 className="details">
                                  <Link
                                    onClick={() => handleOpen(ticket)}
                                    style={{
                                      textDecoration: "none",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={TransactionPNG}
                                      alt=""
                                      className="TransactionPNG small-svg"
                                    />
                                    <Typography variant="span">
                                      Transaction
                                    </Typography>
                                  </Link>
                                </Grid2>
                                {ticket.assigned_organizer == 0 && ticket.resellstatus == "On"?
                                <Grid2 className="details">
                                  <Link
                                    to={`/my-tickets/resell-ticket-details/${ticket.ut_id}`}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <img
                                      src={ResellPNG}
                                      alt=""
                                      className="small-svg ResellPNG"
                                    />
                                    <Typography variant="span">
                                      Resell
                                    </Typography>
                                  </Link>
                                </Grid2>
                                :""
                                }
                                
                              </Grid2>
                            </CardContent>
                          </CardContent>
                        </Card>
                      </Box>
                    </div>
                  );
                })
              ) : (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: "center", marginTop: "20px" }}
                >
                  No tickets found.
                </Typography>
              )}
            </div>
                      }
            </>
            
          )}
        </Box>
        <Footer />
      </div>
      {/* Transaction Details Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Transaction details</DialogTitle>
        <Button onClick={handleClose} className="close-btn">
          <img src={closeBtn} alt="" />
        </Button>
        <DialogContent dividers>
          {selectedTicket && (
            <>
              {/** Call formatEventDate for selectedTicket */}
              {selectedTicket &&
                (() => {
                  const { formatedTransactionDate } = formatEventDate(
                    selectedTicket.start_datetime,
                    selectedTicket.end_datetime,
                    selectedTicket.start_time + " - " + selectedTicket.end_time,
                    selectedTicket.event_ticket_date,
                    selectedTicket.transaction_date
                  );

                  return (
                    <>
                      <Typography variant="body1">
                        <strong>Quantity : </strong>
                        {selectedTicket.quantity}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Amount : </strong> ₹{" "}
                        {selectedTicket.purchase_price}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Date : </strong> {formatedTransactionDate}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Payment Id : </strong>{" "}
                        {selectedTicket.payment_id}
                      </Typography>
                    </>
                  );
                })()}
            </>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Myticket;
